import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
				<div className="navbar navbar-purina-red" role="navigation">
					<div className="container">

						<div className="nav navbar-nav navbar-right" id="powered_by_purina">
							<div className="parent-brand-logo pull-right">
								{/*<a href="http://www.purina.it" title="Purina, Your Pet, Our Passion" target="_blank">*/}
								{/*	<img alt="Purina, Your Pet, Our Passion" src="https://www.petpassion.tv/global17/img/purina-top-brand-logo.png" />*/}
								{/*</a>*/}
							</div>
							<div className="powered_by pull-right">
								{/*<p> Petpassion è powered by Purina. Scopri chi siamo <i className="fa fa-long-arrow-right" aria-hidden="true"/></p>*/}
							</div>
						</div>
            </div>
				</div>
				<div className="container container-header header">
					<div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 brand" id="brand">
						<a href="/"> <img src="https://www.petpassion.tv/global17/img/purina_logo_header_gray_tv.png" className="img-responsive img-logo-purina" alt="Purina Logo"/> </a>
					</div>
					<div className="col-lg-8 col-md-6 col-sm-12 col-xs-12 community-header">
						<div className="community-title"> La community di chi <i style={{color:"#ea2227"}} className="fa fa-heart" aria-hidden="true"></i> gli animali</div>
					</div>
				</div>
      </header>
      <div className="main">

        <div className={"container"}>
          <section className={"first-section"}>
            <img className={"dogs"} src={"assets/img/logo10anni.png"} />
						<img className={"writings"}  src={"assets/img/festeggiaConNoi.png"} />
          </section>
          <section>
            <p className={"par1"}>Passo dopo passo abbiamo raggiunto un importante traguardo fatto di amore e amicizia, di fusa e coccole: <br/>la community di <strong>PetPassion.tv compie 10 anni</strong>!</p>
          </section>
        </div>

				<div className={"balloons-section"} style={{ marginBottom: "200px"}}>
					<div className={"container container-special"}>
						<img className={"balloons"} src={"assets/img/balloons.png"} />
					</div>
					<div className={"container"}>
						<video autoPlay muted controls>
							<source src={"assets/video.mp4"} />
						</video>
					</div>
				</div>

				{/*<div className={"section-ecard mobile-hidden"} style={{background: "#fff", marginTop: "2.5em"}}>
					<div className={"container flex"}>
						<div className={"col-md-6 col-xs-12 payoff"}>
							<img src={"assets/img/condividitxt.png"} style={{height: "150px", maxWidth: "100%"}} />
							<a href={"https://www.petpassion.tv/card/10-anni"} className={"cta"}>Condividi la tua foto!</a>
						</div>
						<div className={"col-md-6 col-xs-12 ecard"}>
							<img src={"assets/img/fotoframe.png"} style={{width: "100%", marginTop: "-30px"}} />
						</div>
					</div>
				</div>*/}

				<div className={"section-ecard desktop-hidden"} style={{background: "#fff", marginTop: "2.5em"}}>
					<div className={"container"} style={{background: "#fff"}}>
						<div className={"col-md-6 col-xs-12 ecard"}>
							<img src={"assets/img/fotoframe.png"} style={{width: "100%", marginTop: "-30px"}} />
						</div>
						<div className={"col-md-6 col-xs-12 payoff"} style={{paddingBottom: "2em"}}>
							<img src={"assets/img/condividitxt.png"} style={{height: "150px", maxWidth: "100%", marginTop: "2em", marginBottom: "2em"}} />
							<a href={"https://www.petpassion.tv/test/show/qual-e-la-tua-pet-passion/116"} className={"cta"} style={{marginTop: "2em"}}>Partecipa al test!</a>
						</div>

					</div>
				</div>

				<div className={"container"} style={{marginTop: "150px", textAlign: "center", marginBottom: "150px"}}>
					<a className={"mobile-hidden"} href={"https://www.petpassion.tv/test/show/qual-e-la-tua-pet-passion/116"}><img className={"sconto"} src={"assets/img/dog-cat-desk.png"} /></a>
					<a className={"desktop-hidden"} href={"https://www.petpassion.tv/test/show/qual-e-la-tua-pet-passion/116"}><img className={"sconto"} src={"assets/img/dog-cat-desk.png"} /></a>
				</div>

      </div>

			<footer className="">
				<div className="top-footer-purina">
					<div className="container ">
						<div className="list-group-horizontal-footer">
							{/*<a href="https://www.purina.it/prodotti" className="list-group-item">
								<h5> Scopri i nostri prodotti </h5>
								<img
										src="https://petpassion.dgthouse.com/global17/img/xpurina-logo-footer.png.pagespeed.ic.Q33p-_uvhy.webp"
										className="" alt="Purina Logo" data-pagespeed-url-hash="4028021118"
										onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>
							</a>
							<a href="https://www.purina.it/purina-risponde" target="_blank" className="list-group-item">
								<h5> Hai domande? </h5>
								<p> Purina ti risponde </p>
							</a>*/}
							<a href="mailto:info@petpassion.tv" target="_blank" className="list-group-item">
								<h5> Contattaci </h5>
								<p> Scrivi a PetPassion </p>
							</a>
							{/*<a href="https://www.purina.it/cerca-cucciolo" target="_blank" className="list-group-item">
								<h5> Cerca un cucciolo </h5>
								<p> Leggi la guida e la lista degli allevatori </p>
							</a>
							<a href="https://www.purina.it/petmap" target="_blank" className="list-group-item">
								<h5> Scopri la Pet Map </h5>
								<p> Tutti i servizi dedicati al tuo pet in pochi click </p>
							</a>*/}
						</div>
						{/*<div className="clearfix" id="brands">
							<div className="content">
								<div className="brands clearfix">
									<a href="https://www.purina.it/prodotti/adventuros" className="" target="_blank">
<span>
<img src="https://dt-petpassion.s3.amazonaws.com/blog/uploads/2018/10/adventuros_logo.png" alt="Adventuros"
		 title="Adventuros" data-pagespeed-url-hash="3193573681"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
									<a href="https://www.purina-beyond.it/" className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/logo-purina-beyond.png?itok=pRmFm6WR"
		 alt="Beyond" title="Beyond" data-pagespeed-url-hash="4149201115"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>

									<a href="https://www.purina.it/prodotti/prodotti-per-cani/dentalife" className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/dentalife_logo_big.png?itok=tdkmQ6eK"
		 alt="Dentalife" title="Dentalife" data-pagespeed-url-hash="1696796003"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
									<a href="https://www.purina-felix.it/" className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/Felix_senza_payoff.png?itok=cznl71Nn"
		 alt="" data-pagespeed-url-hash="3207422622"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);" />	</span>
									</a>
									<a href="https://www.purina-friskies.it/" className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/FRIPURINA.png?itok=vb84e-8S"
		 alt="Friskies" title="Friskies" data-pagespeed-url-hash="1562738142"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
									<a href="https://www.gourmet-gatto.it/ " className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/field/image/logo-gourmet-purina.png" alt="Gourmet" title="Gourmet"
		 data-pagespeed-url-hash="4195330653" onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
									<a href="https://www.purina.it/cat-chow/ " className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/cat_chov_2016.png?itok=pHtj63dr"
		 alt="Tonus CatChow" title="Tonus CatChow" data-pagespeed-url-hash="2345214357"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
									<a href="https://www.purinaone.it/ " className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/ONEPN.png?itok=MZEWh98x" alt="Purina ONE"
		 title="Purina ONE" data-pagespeed-url-hash="3861748239"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
									<a href="https://www.purina-proplan.it/ " className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/3.png?itok=npIL8xS5" alt="Purina Pro Plan"
		 title="Purina Pro Plan" data-pagespeed-url-hash="3556605405"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
									<a href="https://www.purina-proplan.it/cane/alimenti/diete-veterinarie" className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/logo_vet_small.png?itok=ugKIxyCX"
		 alt="Purina Pro Plan Veterinary Diets" title="Purina Pro Plan Veterinary Diets"
		 data-pagespeed-url-hash="1114729188" onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
									<a href="https://www.purina.it/prodotti/prodotti-per-cani/tonus " className="" target="_blank">
<span>
<img src="https://www.purina.it/sites/default/files/styles/logo_medium/public/tonus_dog.png?itok=SSRflhtT"
		 alt="Tonus Dog" title="Tonus Dog" data-pagespeed-url-hash="3548547389"
		 onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>	</span>
									</a>
								</div>
							</div>
						</div>*/}
					</div>
				</div>
				<div className="container-fluid bottom-footer-purina">
					<div className="container">
						<div className="col-sm-3 col-xs-12">
							<img
									src="https://petpassion.dgthouse.com/global17/img/xpurina_logo_footer_gray_tv_2.png.pagespeed.ic.-h5uBLB5TG.webp"
									className="img-responsive footer-logo" alt="Purina Logo" data-pagespeed-url-hash="1582164284"
									onLoad="pagespeed.CriticalImages.checkImageForCriticality(this);"/>
						</div>
						<div className="menu-footer col-md-6 col-sm-8 col-xs-12">
							<div className="col-md-3 col-sm-6 col-xs-6">
								<p> NAVIGA </p>
								<ul>
									<li><a href="/"> Home </a></li>
									<li><a href="/ad/home"> Cerca/Trova </a></li>
									<li><a href="/community"> Community </a></li>
									<li><a href="/blog/category/faq-community-petpassion"> FAQ </a></li>
								</ul>
							</div>
							<div className="col-md-3 col-sm-6 col-xs-6">
								<p> CREA </p>
								<ul>
									<li><a href="/ad/home"> Pubblica annuncio </a></li>
									<li><a href="/pet/create"> Crea profilo Pet </a></li>
									<li><a href="/upload/photo"> Carica foto </a></li>
									<li><a href="/upload/video"> Carica video </a></li>
								</ul>
							</div>
							<div className="col-md-3 col-sm-6 col-xs-6">
								<p> INFORMAZIONI </p>
								<ul>
									<li><a href="/pages/termini-duso-petpassion-tv"> Termini e condizioni </a></li>
									<li><a href="/pages/informativa-sulla-privacy-di-petpassion-tv"> Informativa sulla privacy </a></li>
									<li><a href="/pages/cookie"> Utilizzo dei cookie </a></li>
									<li><a href="/groups"> Partecipa alle discussioni </a></li>
									<li><a href="/register/step-1"> Iscriviti </a></li>
								</ul>

							</div>
						</div>
						<div className="col-sm-3 col-xs-12">
							<div className="footer-social-icons">
								<ul className="social-icons">
									<li><a href="https://www.facebook.com/petpassion.tv/" target="_blank" className="social-icon"> <i className="fa fa-facebook"></i></a></li>
									<li><a href="https://www.youtube.com/channel/UC-A0DTJqJKH2vPKxhVzunZA" target="_blank" className="social-icon"> <i className="fa fa-youtube"></i></a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</footer>
    </div>
  );
}

export default App;
